// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3byDQ","inner":"Form_inner__25r2I","range":"Form_range__1Dqws","name":"Form_name__uSKOy","actions":"Form_actions__2NFmG"};